module.exports = __webpack_public_path__ + "img/insta-icon.d1fc6695.svg";